export default __webpack_public_path__ + "static/media/right-arrow.3988128f.svg";